import { jsx } from 'react/jsx-runtime';
import 'react';
import { Skeleton as Skeleton$1 } from 'baseui/skeleton';
import 'baseui/skeleton/types';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { useResolvedStyle, mergeStyles } from '../../theme/utils.js';
import '../../theme/types.js';
import { mergeOverrides } from '../../overrides.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getStyles = (theme, variant, animation) => {
  switch (variant) {
    case "image":
      return {
        borderRadius: theme.radii["4"],
        backgroundColor: theme.colors["background-brand-disabled"],
        backgroundImage: animation ? `linear-gradient(90deg, ${theme.colors["background-brand-disabled"]}, ${theme.colors["background-brand-disabled"]}, ${theme.colors["background-brand-disabled"]}, ${theme.colors["background-global-secondary"]}, ${theme.colors["background-brand-disabled"]}, ${theme.colors["background-brand-disabled"]})` : void 0
      };
    default:
      return {
        borderRadius: theme.radii["4"],
        backgroundColor: theme.colors["background-global-secondary"],
        backgroundImage: animation ? `linear-gradient(90deg, ${theme.colors["background-global-secondary"]}, ${theme.colors["background-global-secondary"]}, ${theme.colors["background-global-secondary"]}, ${theme.colors["background-global-secondary"]}, ${theme.colors["background-global-secondary"]},${theme.colors["background-global-secondary"]},${theme.colors["background-global-secondary"]}, ${theme.colors["background-global-primary"]}, ${theme.colors["background-global-secondary"]},${theme.colors["background-global-secondary"]},${theme.colors["background-global-secondary"]},${theme.colors["background-global-secondary"]},${theme.colors["background-global-secondary"]}, ${theme.colors["background-global-secondary"]})` : void 0
      };
  }
};
const Skeleton = (_a) => {
  var _b = _a, { animation = true, variant = "text", $style, overrides } = _b, props = __objRest(_b, ["animation", "variant", "$style", "overrides"]);
  const resolvedStyle = useResolvedStyle($style);
  return jsx(Skeleton$1, __spreadValues({ animation, overrides: mergeOverrides({
    Root: {
      style: ({ $theme }) => !props.rows ? mergeStyles(getStyles($theme, variant, animation), resolvedStyle) : void 0
    },
    Row: {
      style: ({ $theme }) => getStyles($theme, variant, animation)
    }
  }, overrides) }, props));
};

export { Skeleton };
